<template>
    <div>

        <vue-headful title="Report Builder :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active">Build a Report</li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-form-label text-sm-right">Select the data to use</label>
                    <div class="ml-3">
                        <select class="form-control" v-model="params.data_type">
                            <option :value="null">-- Select Data Type --</option>
                            <option v-for="(option, id) in data_options" :value="id">{{ option }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label text-sm-right">Select the type of graph</label>
                    <div class="ml-3">
                        <select class="form-control" v-model="params.graph_type">
                            <option :value="null">-- Select Graph Type --</option>
                            <option v-for="(option, id) in graph_options" :value="id">{{ option }}</option>
                        </select>
                    </div>
                </div>
                <template v-if="params.graph_type == 'bar' || params.graph_type == 'line'">
                    <div class="form-group row">
                        <label class="col-form-label text-sm-right">Select the data grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.primary_group">
                                <option :value="null">-- Select Grouping Type --</option>
                                <option v-for="(option, id) in grouping_options[params.data_type]" :value="id">{{ option }}</option>
                                <option v-for="(option, id) in time_grouping_options[params.data_type]" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="showTimeGroup" class="form-group row">
                        <label class="col-form-label text-sm-right">Select the time grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.time_group">
                                <option :value="null">-- Select Time Grouping --</option>
                                <option v-for="(option, id) in time_options" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                </template>
                <template v-else-if="params.graph_type == 'grouped_bar' || params.graph_type == 'stacked_bar' || params.graph_type == 'grouped_line'">
                    <div class="form-group row">
                        <label class="col-form-label text-sm-right">Select the primary data grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.primary_group">
                                <option :value="null">-- Select Grouping Type --</option>
                                <option v-for="(option, id) in time_grouping_options[params.data_type]" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="showTimeGroup" class="form-group row">
                        <label class="col-form-label text-sm-right">Select the time grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.time_group">
                                <option :value="null">-- Select Time Grouping --</option>
                                <option v-for="(option, id) in time_options" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label text-sm-right">Select the secondary data grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.secondary_group">
                                <option :value="null">-- Select Grouping Type --</option>
                                <option v-for="(option, id) in grouping_options[params.data_type]" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                </template>
                <template v-else-if="params.graph_type == 'pie'">
                    <div class="form-group row">
                        <label class="col-form-label text-sm-right">Select the data grouping</label>
                        <div class="ml-3">
                            <select class="form-control" v-model="params.primary_group">
                                <option :value="null">-- Select Grouping Type --</option>
                                <option v-for="(option, id) in grouping_options[params.data_type]" :value="id">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                </template>
                <highcharts :options="options" style="height: 1000px;"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                series: [],
                labels: [],
                isLoading: false,
                data_options: {},
                graph_options: {},
                grouping_options: {},
                time_grouping_options: {},
                time_options: {},
                params: {
                    data_type: 'inspections',
                    graph_type: null,
                    primary_group: null,
                    secondary_group: null,
                    time_group: null,
                },
            }
        },
        watch: {
            params: {
                deep: true,
                handler(params) {
                    this.getData();
                },
            },
            'params.graph_type'(newValue, oldValue) {
                if (newValue == 'bar' || newValue == 'line')
                {
                    this.params.secondary_group = null;
                }
            },
        },
        computed: {
            showTimeGroup: function() {
                if (this.params.primary_group == 'inspection.InspectionDate')
                {
                    return true;
                }

                return false;
            },
            options: function()
            {
                // Anything that is set in the switch needs to have its default set here
                // For example, if stacking:undefined is left off, once stacked bar is selected
                // the grouped bar will ALSO stack
                let options = {
                    chart: {
                        type: null,
                    },
                    title: {
                        text: 'Things' // get this from somewhere
                    },
                    xAxis: {
                        categories: this.labels
                    },
                    yAxis: {
                        title: {
                            text: '# of Things' // get this from somewhere
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                            },
                            stacking: undefined,
                        },
                        line: {
                            dataLabels: {
                                enabled: true,
                            },
                        }
                    },
                    legend: {
                        layout: 'horizontal',
                        align: 'right',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0,
                        floating: false,
                        borderColor: '#dddddd',
                        borderWidth: 1,
                    },
                    series: this.series,
                };
                switch(this.params.graph_type)
                {
                    case 'grouped_bar':
                    case 'bar':
                        options.chart.type = 'bar';
                        break;
                    case 'stacked_bar':
                        options.chart.type = 'bar';
                        options.plotOptions.bar.stacking = 'normal'
                        break;
                    case 'line':
                        options.chart.type = 'line';
                        break;
                    case 'grouped_line':
                        options.chart.type = 'line';
                        break;
                    case 'pie':
                        options.chart.type = 'pie';
                        break;
                }
                return options;
            }
        },

        methods: {
            getData: function() {
                this.$http
                    .get('reports/new-report-data', this.params)
                    .then(response => {
                        if(response.data.series.length === 0)
                        {
                            //Alert the user
                            this.$toastr.warning('There is no data for your currently selected filters.')

                            //Stop here
                            return;
                        }

                        //Set all the data
                        this.labels = response.data.labels;
                        this.series = response.data.series;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            }
        },

        mounted() {
            this.$http
                .get('reports/new-report')
                .then(response => {
                    //Set all the data
                    this.data_options = response.data.data_options;
                    this.graph_options = response.data.graph_options;
                    this.grouping_options = response.data.grouping_options;
                    this.time_grouping_options = response.data.time_grouping_options;
                    this.time_options = response.data.time_options;

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        }
    }
</script>
